import React, { useState, useRef } from 'react';
import { Button, Input, Modal } from 'antd';

const InputWithPopUp = ({
  value,
  onChange,
  onBlur,
  modalTitle = 'Importante',
  modalContent = '',
  ...restProps
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const hasBlurredRef = useRef(false);

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
    if (!hasBlurredRef.current) {
      setIsModalOpen(true);
      hasBlurredRef.current = true;
    }
  };

  return (
    <>
      <Input
        {...restProps}
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
      />
      <Modal
        title={modalTitle}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        closable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => setIsModalOpen(false)}
          >
            Entendido
          </Button>,
        ]}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default InputWithPopUp;
